function path(root: string, sublink: string) {
    return `${root}${sublink}`;
  }
  
const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  // loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  // register: path(ROOTS_AUTH, '/register'),
  // registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  newPassword: path(ROOTS_AUTH, '/new-password'),
  verify: path(ROOTS_AUTH, '/verify')
};

export const PATH_PAGE = {
  home: '/home'
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    app: path(ROOTS_DASHBOARD, '/app'),
    policies: path(ROOTS_DASHBOARD, '/policies'),
    sports: path(ROOTS_DASHBOARD, '/sports'),
    createSport: path(ROOTS_DASHBOARD, '/sports/create'),
    certificates: path(ROOTS_DASHBOARD, '/certificates'),
    createCertificate: path(ROOTS_DASHBOARD, '/certificates/create'),
    insureds: path(ROOTS_DASHBOARD, '/insureds'),
    createInsured: path(ROOTS_DASHBOARD, '/insureds/create'),
    products: path(ROOTS_DASHBOARD, '/products'),
    createProduct: path(ROOTS_DASHBOARD, '/products/create')
  },
  insurers:{
    sura: path(ROOTS_DASHBOARD, '/insurers/sura'),
    zurich: path(ROOTS_DASHBOARD, '/insurers/zurich')
  }
};